import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { useEffectEvent } from "@faire/web--source/ui/hooks/useEffectEvent";
import { trackApparelBrandRetailerPdpWithMixedShippingView } from "@faire/web-api--source/events/apparelBrand/view/retailerPdpWithMixedShipping";
import { trackProductsPageViaImpressionView } from "@faire/web-api--source/events/products/view/pageViaImpression";
import { trackRetailerPosShopifyReorderLinkProductClick } from "@faire/web-api--source/events/retailerPos/click/shopifyReorderLinkProduct";
import { IDwellTime } from "@faire/web-api--source/indigofair/data/IDwellTime";
import { useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { recordLandingActivity, recordSignupActivity } from "@faire/retailer/actions/user/recordLoggedOutActivity";
import { useAppSignUpPageResultsUpdateEffect } from "@faire/retailer/components/AppSignUp/AppSignUpPageResultsProvider";
import { PageInitialized, ViewProduct } from "@faire/retailer-visitor-shared/events";
import { useFaireDirectBrand } from "@faire/retailer/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { useIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { useIsLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { popSignUp, SignUpElement, SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { useDwellService } from "@faire/retailer/services/DwellService";
import { PageLoadEvent } from "@faire/retailer/services/performance/const";
import { PerformanceMarker } from "@faire/retailer/services/performance/PerformanceMarker";
import { useAssignSettingFaireDirectPDPSignup, useSettingFaireDirectPDPSignup } from "@faire/retailer/settings/useSettingFaireDirectPDPSignup";
import { useSettingFeEvents } from "@faire/retailer/settings/useSettingFeEvents";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { AppModalStore } from "@faire/retailer-visitor-shared/stores/ui/AppModalStore";
import { useAppSnackbarStore } from "@faire/retailer/stores/ui/AppSnackbarStore";
import { getProductDetails, getProductName, isMixedProduct } from "@faire/retailer/views/product/utils/productUtils";
export var ProductPageEffects = function(param) {
    var brand = param.brand, product = param.product, queryParams = param.queryParams, productToken = param.productToken;
    useEffect(function() {
        PageInitialized.publish();
    }, []);
    useEffect(function() {
        PerformanceMarker.get().mark(PageLoadEvent.pageStart);
    }, []);
    useEffect(function() {
        ViewProduct.publish(getProductDetails(product));
    }, [
        product
    ]);
    var pathname = useLocation().pathname;
    var history = useHistory();
    var recordLoggedOutActivity = useEffectEvent(function() {
        var loggedOutActivity = {
            product_token: product === null || product === void 0 ? void 0 : product.token,
            brand_token: brand === null || brand === void 0 ? void 0 : brand.token
        };
        recordLandingActivity(loggedOutActivity, history);
        recordSignupActivity(loggedOutActivity, pathname);
    });
    var useFeEvents = useSettingFeEvents();
    var partner = queryParams.get("partner");
    useEffect(function() {
        if (useFeEvents && history.length <= 1 && partner === "shopify_reorder") {
            trackRetailerPosShopifyReorderLinkProductClick();
        }
    }, [
        useFeEvents,
        history.length,
        partner
    ]);
    useEffect(recordLoggedOutActivity, [
        recordLoggedOutActivity
    ]);
    var impressionId = queryParams.get("impressionId");
    useEffect(function() {
        if (product.token && impressionId) {
            trackProductsPageViaImpressionView(product.token, impressionId);
        }
    }, [
        product.token,
        impressionId
    ]);
    var _useDwellService = useDwellService([
        "start",
        "stop"
    ]), startDwell = _useDwellService.start, stopDwell = _useDwellService.stop;
    useEffect(function() {
        var _product_token;
        startDwell((_product_token = product.token) !== null && _product_token !== void 0 ? _product_token : "", IDwellTime.Type.PRODUCT);
        return function() {
            stopDwell();
        };
    }, [
        startDwell,
        stopDwell,
        product.token
    ]);
    var _useAppSnackbarStore = _sliced_to_array(useAppSnackbarStore([]), 2), _ = _useAppSnackbarStore[0], setAppSnackbarStore = _useAppSnackbarStore[1];
    useEffect(function() {
        setAppSnackbarStore({
            productTitle: getProductName(product)
        });
        return function() {
            setAppSnackbarStore({
                productTitle: undefined
            });
        };
    }, [
        product,
        setAppSnackbarStore
    ]);
    var retailerToken = useRetailerStore([
        "retailerToken"
    ]).retailerToken;
    var isBrandPreview = useIsBrandPreview();
    useEffect(function() {
        if (!isBrandPreview && product.token && isMixedProduct(product)) {
            trackApparelBrandRetailerPdpWithMixedShippingView(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", product.token);
        }
    }, [
        isBrandPreview,
        product,
        retailerToken
    ]);
    var trackEventToken = queryParams.get("trackEventToken");
    useEffect(function() {
        var eventPath = "/retailer/".concat(retailerToken);
        // IMPORTANT - Do not remove. BE uses this to calculate product page visits.
        trackEvent("".concat(eventPath, "/product-page/").concat(productToken));
        if (trackEventToken) {
            trackEvent("".concat(eventPath, "/product-page/").concat(productToken, "/").concat(trackEventToken));
        }
    }, [
        productToken,
        trackEventToken,
        retailerToken
    ]);
    useAppSignUpPageResultsUpdateEffect({
        pdpProduct: product
    });
    useAutoSignUpEffects(queryParams);
    var isLoggedInRetailerOrBrandPreview = useIsLoggedInRetailerOrBrandPreview();
    var isFaireDirectActiveInLoggedOut = useFaireDirectBrand().isFaireDirectActiveInLoggedOut;
    var assignSettingFaireDirectPDPSignup = useAssignSettingFaireDirectPDPSignup();
    useEffect(function() {
        if (!isLoggedInRetailerOrBrandPreview && isFaireDirectActiveInLoggedOut) {
            assignSettingFaireDirectPDPSignup();
        }
    }, [
        assignSettingFaireDirectPDPSignup,
        isFaireDirectActiveInLoggedOut,
        isLoggedInRetailerOrBrandPreview
    ]);
    return null;
};
var useAutoSignUpEffects = function(queryParams) {
    var queryParamSignUp = queryParams.get("signUp");
    var settingFaireDirectPDPSignup = useSettingFaireDirectPDPSignup();
    var isLoggedInRetailerOrBrandPreview = useIsLoggedInRetailerOrBrandPreview();
    var isFaireDirectActiveInLoggedOut = useFaireDirectBrand().isFaireDirectActiveInLoggedOut;
    var history = useHistory();
    var autoSignUpTimeoutHandleRef = useRef(undefined);
    useEffect(function() {
        // Handle the case when there is another sign-up modal shown before our timeout executes.
        // If the user already closed the modal, we want to react to the the query param changing,
        // and cancel the timer so we don't show the sign-up modal again and annoy the user.
        clearTimeout(autoSignUpTimeoutHandleRef.current);
    }, [
        queryParamSignUp
    ]);
    useEffect(function() {
        if (isLoggedInRetailerOrBrandPreview || settingFaireDirectPDPSignup) {
            return;
        }
        if (isFaireDirectActiveInLoggedOut) {
            autoSignUpTimeoutHandleRef.current = setTimeoutIfPossible(function() {
                if (!AppModalStore.get().isModalShowing) {
                    popSignUp(history, SignUpType.FAIRE_DIRECT, function() {
                        return null;
                    }, {
                        element: SignUpElement.AUTO_POPUP,
                        sourceId: "faire_direct_auto_signup"
                    });
                }
            }, 5000);
        }
        return function() {
            clearTimeout(autoSignUpTimeoutHandleRef.current);
        };
    }, [
        isFaireDirectActiveInLoggedOut,
        isLoggedInRetailerOrBrandPreview,
        settingFaireDirectPDPSignup,
        history
    ]);
};
